/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";

import styles from "./index.module.css";

interface Signature {
  Element: HTMLDivElement;
  Args: {
    onChange?: unknown;
    start?: unknown;
  };
}

export default class FeelingSlider extends Component<Signature> {
  styles = styles;

  @action
  labels(labels: string[], value: number): string {
    if (!labels[value]) return "";

    // HACK: using "&nbsp;" here to fix a positionning bug
    return "&nbsp;" + labels[value];
  }
}
